<template>
  <div class="price">
    <div class="price__panel">
      <div class="price__panel__display">
        {{price ? $n(price, 'currency') : $t('services.price.none') }}
        {{ $t('base.priceType', priceTypeKey) }}
      </div>
      <p class="price__panel__subtitle">
        {{ $t('comparator.offers.offer.rateGuaranteed') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';

export default {
  name: 'servicePrice',
  props: {
    price: {
      type: Number,
    },
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    exclTax() {
      return this.demand.show_price_ht;
    },
    priceTypeKey() {
      return this.demand.priceTypeKey;
    },
  },
};
</script>

<style scoped lang="scss">
  .price {
    color: var(--nxt-color-font);
    text-align: center;
    height: 100%;
    &__panel {
      height: 100%;
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 20px 10px;
      border-radius: 4px;
      background-color: var(--nxt-color-light-grey);
      &__display {
        font-size: 25px;
        font-weight: 700;
      }
      &__subtitle {
        margin: 0;
      }
    }
  }
</style>
